import React from 'react';
import PropTypes from 'prop-types';
import SearchSuggestion from './Search-suggestion';
import {historyPush, getLinkQueryString} from '../services/history';
import {intlShape, injectIntl} from 'react-intl';
import {getCategoriesByQuery, getPopularSearchesByQuery} from '../services/utils';
import {getSearch} from '../services/market-api';
import {execBI} from '../services/bi-events-manager';
import injectMain from '../services/inject-main';
import _ from 'lodash';

const maxAppsCount = 3, maxPopularCount = 3, maxCategoryCount = 2;
const defaultPopularTranslate = ['search.popular.store', 'search.popular.bookings', 'search.popular.faq', 'search.popular.popup'];

const getSearchThrottle = _.throttle((query, lang, limit, callback) => {
  // Can't use Promises, throttle would always return first fulfilled Promise
  getSearch(query, lang, limit)
    .then((resp) => callback(null, resp))
    .catch((err) => callback(err));
}, 800);

class SearchBox extends React.Component {

  static propTypes = {
    categories: PropTypes.array.isRequired,
    className: PropTypes.string,
    search: PropTypes.string,
    intl: intlShape.isRequired,
    lang: PropTypes.string,
    fullUrl: PropTypes.string,
    query: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  execSearchSuggestion() {
    if (this.state.lastSuggestion === this.input.value) {
      return;
    }

    this.setState({
      popular: getPopularSearchesByQuery(this.input.value, maxPopularCount),
      categories: getCategoriesByQuery(this.props.categories, this.input.value, maxCategoryCount),
      lastSuggestion: this.input.value
    });

    if (this.input.value.length >= 2) {
      getSearchThrottle(this.input.value, this.props.lang, maxAppsCount, (err, resp) => {
        if (err) {
          this.setState({apps: []});
        } else {
          this.setState({apps: resp});
        }
      });

    } else {
      this.setState({apps: []});
    }
  }

  handleOnChange() {
    this.execSearchSuggestion();
    execBI('UPDATE_AUTO_COMPLETE_QUERY', {query: this.input.value, results: {query: this.input.value, applications: []}});

    if (this.input.value.length) {
      this.clear.classList.add('search-box-clear-visible');
    } else {
      this.clear.classList.remove('search-box-clear-visible');
    }
  }

  handleKeyDown(ev) {
    if (ev.keyCode === 40) {
      ev.preventDefault();
      const total = this.isEmptyQuery() ?
        defaultPopularTranslate.length :
        this.state.popular.length + this.state.apps.length + this.state.categories.length;

      this.setState({activeIndex: Math.min(this.state.activeIndex + 1, total - 1)});

    } else if (ev.keyCode === 38) {
      ev.preventDefault();
      this.setState({activeIndex: Math.max(this.state.activeIndex - 1, -1)});

    } else if (ev.keyCode === 13) {
      if (getSearchThrottle.cancel) {
        getSearchThrottle.cancel();
      }

      if (this.state.activeIndex !== -1) {
        ev.preventDefault();
        const active = this.container.querySelector('.search-suggestion .active');
        if (active) {
          this.input.blur();
          active.firstElementChild.click();
        }
      }
    }
  }

  handleOnFocus() {
    this.execSearchSuggestion();
    execBI('SEARCH_INPUT_FOCUS');

    this.container.parentElement.classList.add('search-focus');
    this.setState({showSuggestion: true, activeIndex: -1});
  }

  handleOnBlur() {
    setTimeout(() => {
      this.container.parentElement.classList.remove('search-focus');
      this.setState({showSuggestion: false});
    }, 200);
  }

  handleOnSubmit(ev) {
    ev.preventDefault();
    if (this.input.value.length === 0) {
      return;
    }
    this.input.blur();
    execBI('SEARCH_INPUT_SUBMIT', {search_term: this.input.value, origin: 'direct'});
    historyPush(`/search/${getLinkQueryString({q: this.input.value})}`);
  }

  isEmptyQuery() {
    return !(this.input && this.input.value.length > 0);
  }

  showPopover() {
    const state = this.state || {};

    return !!(this.isEmptyQuery() ||
      state.popular.length ||
      state.apps.length ||
      state.categories.length);
  }

  componentDidMount() {
    this.input.value = this.props.search;
    this.input.removeAttribute('name');
    if (this.input.value.length) {
      this.clear.classList.add('search-box-clear-visible');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search !== this.props.search) {
      this.input.value = nextProps.search;
    }

    this.clear.classList[this.input.value.length ? 'add' : 'remove']('search-box-clear-visible');
    this.setState({activeIndex: -1});
  }

  componentWillMount() {
    this.setState({
      popular: [],
      apps: [],
      categories: [],
      activeIndex: -1
    });
  }

  searchBoxClick() {
    this.input.focus();
    this.handleOnFocus();
  }

  handleClearClick(ev) {
    ev.preventDefault();
    this.input.value = '';
    this.clear.classList.remove('search-box-clear-visible');
  }

  render() {
    const {formatMessage} = this.props.intl;
    const state = this.state || {};

    const defaultPopular = defaultPopularTranslate.map((i) => formatMessage({id: i}));
    const results = {popular: state.popular, apps: state.apps, categories: state.categories};

    return (
      <div className={this.props.className} ref={i => this.container = i}>
        <div className="search-box">
          <div onClick={() => this.searchBoxClick()} className="search-box-click"></div>
          <form onSubmit={this.handleOnSubmit} className="search-box-form" action={`${this.props.fullUrl}/search/`} method="get">
            <input type="hidden" name="metaSiteId" value={this.props.query.metaSiteId}/>
            <input
              name="q"
              className="search-box-input typography_t2_1"
              type="text"
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              onChange={this.handleOnChange}
              onKeyDown={this.handleKeyDown}
              placeholder={formatMessage({id: 'search.placeholder'})}
              ref={c => this.input = c}
              maxLength="100"
              />
            <input className="search-box-submit" type="submit" value=""/>

            <a href="#" className="search-box-clear" ref={c => this.clear = c} onClick={(ev) => this.handleClearClick(ev)}>
              <svg width="8px" height="8px" viewBox="0 0 11 11"><g><path d="M6.613 5.492l4.27 4.27a.397.397 0 0 1 0 .56l-.56.56a.397.397 0 0 1-.56 0l-4.269-4.27-4.27 4.27a.397.397 0 0 1-.56 0l-.56-.56a.397.397 0 0 1 0-.56l4.27-4.27-4.27-4.269a.397.397 0 0 1 0-.56l.56-.56a.397.397 0 0 1 .56 0l4.27 4.27L9.763.103a.397.397 0 0 1 .56 0l.56.56a.397.397 0 0 1 0 .56l-4.27 4.269z"></path></g></svg>
            </a>
          </form>

          <SearchSuggestion
            empty={this.isEmptyQuery()}
            show={state.showSuggestion && this.showPopover()}
            defaultPopular={defaultPopular}
            results={results}
            activeIndex={state.activeIndex}
            getInputValue={() => this.input.value}
            />
        </div>
      </div>
    );
  }
}


export default injectMain(injectIntl(SearchBox));



// WEBPACK FOOTER //
// ./components/Search-box.js